import {Type} from '@mintdata/mint-kit/api/types/Type';
import {FieldName, IFrameField} from '@mintdata/mint-kit/api/values/frames/Frame';

export class FrameField implements IFrameField
{
    constructor(public readonly name:FieldName,
                public readonly type:Type)
    {
    }

    public static newErrorField(fieldName:FieldName):FrameField
    {
        return new FrameField(fieldName, Type.Error);
    }

    public clone():FrameField
    {
        return new FrameField(this.name, this.type);
    }
}
